// A hatched slug for a value that has never been known -- the design's rule
// that a gap NEVER renders as `0`. Used by AmountText(value=null) and by
// charts for a `gap` point kind. `label` is required and always rendered
// (visually and to assistive tech) so the gap is never a silent blank.
export function GapBar({
  width = 'md',
  label,
  className,
}: {
  width?: 'sm' | 'md';
  label: string;
  className?: string;
}) {
  const widthClass = width === 'sm' ? 'w-12' : 'w-20';
  return (
    <span
      className={['inline-flex items-center gap-2', className].filter(Boolean).join(' ')}
      data-testid="gap-bar"
    >
      <span
        aria-hidden="true"
        className={['ms-hatch h-3 rounded-sm border border-border-strong', widthClass].join(' ')}
      />
      <span className="text-xs text-muted-foreground">{label}</span>
    </span>
  );
}

export default GapBar;
